import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { connect } from 'react-redux';
import { setEditing, updateTasks, deleteTasks } from 'bundles/apex/deals/show/store/planner_bulk_actions/actions';

import Button from 'shared/button';
import DateChangeModal from './date_change_modal';
import DeleteModal from './delete_modal';
import MarkCompleteModal from './mark_complete_modal';
import ReassignModal from './reassign_modal';
import Snackbar from 'shared/snackbar';

import './styles.scss';

export function PlannerBulkEdit({ editing, selection, setEditing, updateTasks, deleteTasks }) {
  const [showReassignModal, setShowReassignModal] = useState(false);
  const [showMarkCompleteModal, setShowMarkCompleteModal] = useState(false);
  const [showDateChangeModal, setShowDateChangeModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [snackbarText, setSnackbarText] = useState();

  const activateSnackbar = (text) => {
    setSnackbarText(text);
    setShowSnackbar(true);
  };

  const handleDelete = async (text) => {
    await deleteTasks();
    activateSnackbar(text);
  };

  const handleUpdate = async (changes, text) => {
    const response = await updateTasks(changes);
    if (!response.errors) {
      activateSnackbar(text);
    }

    return response;
  };

  const snackbar = (
    <Snackbar
      position="top"
      show={showSnackbar}
      text={snackbarText}
      variant="success"
      onClose={() => setShowSnackbar(false)}
    />
  );

  if (!editing) {
    return (
      <React.Fragment>
        {snackbar}
        <Button.Primary label="Bulk Edit" name="edit-button" onClick={() => setEditing(true)}/>
      </React.Fragment>
    );
  }

  return (
    <div className="d-flex">
      {snackbar}

      <Button.Cancel className="mr-2" label="Cancel" name="cancel-button" outlined onClick={() => setEditing(false)}/>
      <Button.Primary
        className="deal-planner-bulk-dropdown"
        disabled={Object.keys(selection).length === 0}
        dropdownMenuItems={[
          { label: 'Reassign', onClick: () => setShowReassignModal(true) },
          { label: 'Move Due Date', onClick: () => setShowDateChangeModal(true) },
          { label: 'Mark as Complete', onClick: () => setShowMarkCompleteModal(true) },
          { label: 'Delete', onClick: () => setShowDeleteModal(true) }
        ]}
        label="Bulk Actions"
        name="actions-button"
      />

      <ReassignModal
        show={showReassignModal}
        onClose={() => setShowReassignModal(false)}
        onUpdate={handleUpdate}
      />
      <MarkCompleteModal
        show={showMarkCompleteModal}
        onClose={() => setShowMarkCompleteModal(false)}
        onUpdate={handleUpdate}
      />
      <DateChangeModal
        show={showDateChangeModal}
        onClose={() => setShowDateChangeModal(false)}
        onUpdate={handleUpdate}
      />
      <DeleteModal
        show={showDeleteModal}
        onClose={() => setShowDeleteModal(false)}
        onDelete={handleDelete}
      />
    </div>
  );
}

PlannerBulkEdit.propTypes = {
  deleteTasks: PropTypes.func.isRequired,
  editing: PropTypes.bool.isRequired,
  selection: PropTypes.object.isRequired,
  setEditing: PropTypes.func.isRequired,
  updateTasks: PropTypes.func.isRequired,
};

const mapStateToProps = state => ({
  editing: state.plannerBulkActions.editing,
  selection: state.plannerBulkActions.selection,
});

const mapDispatchToProps = {
  setEditing,
  updateTasks,
  deleteTasks
};

export default connect(mapStateToProps, mapDispatchToProps)(PlannerBulkEdit);